export class NoStockMaterialItem {
    stockLocationId: number;
    institutionId: number;
    materialBarcode: string;
    materialId: number;
    deviceId: number;
    patientId: number;
    userName: string;
}
